import api from '.'

export const invitations = {
  get (token, success, fail) {
    api.unauthenticatedRequest('GET', `/invitations?token=${encodeURIComponent(token)}`, null, success, fail)
  },
  accept (token, success, fail) {
    api.authenticatedRequest('POST', `/invitations/accept?token=${encodeURIComponent(token)}`, null, success, fail)
  },
  decline (token, success, fail) {
    api.authenticatedRequest('DELETE', `/invitations?token=${encodeURIComponent(token)}`, null, success, fail)
  }
}
